import React from "react";
import s from "./s.module.less";
import { Modal, Spin, Steps } from "antd";
import StatusLabel from "../../StatusLabel";
import {
    EBillingStatus,
    TPaymentBilling,
    TPaymentEvent,
} from "types/provider";
import dayjs from "utils/dayjs";
import cx from "classnames";

interface Props {
    data: TPaymentEvent[];
    loading?: boolean;
    isInvoice?: boolean;
    item?: TPaymentBilling;
}

const PaymentEvent = ({ data = [], loading, isInvoice, item }: Props) => {
    return (
        <div className={s.paymentTimeline}>
            {loading && (
                <div className={s.loading}>
                    <Spin />
                </div>
            )}
            <Steps
                direction="vertical"
                progressDot
                current={data.length - 1}
                className={s.paymentSteps}
                items={data.map((event) => ({
                    title: (
                        <div className={s.eventTitle}>
                            {/* May 4, 2025, 10:23 AM */}
                            {dayjs(event.eventTime).format(
                                "MMM D, YYYY, HH:mm A"
                            )}
                        </div>
                    ),
                    description: (
                        <div className={s.eventDescription}>
                            <div className={s.descriptionItem}>
                                <span className={s.label}>Status:</span>
                                <StatusLabel value={event.eventStatus as any} isInvoice={isInvoice} item={item} />
                            </div>
                            <div className={s.descriptionItem}>
                                <span className={s.label}>Amount:</span>
                                <span
                                    style={{
                                        color: "#15191E",
                                        fontWeight: 500,
                                    }}
                                >
                                    {(
                                        (event.eventAmountCents || 0) / 100 || (event.eventAmount || 0)
                                    ).toFixed(2)}
                                </span>
                            </div>

                            {event.eventReason &&
                                event.eventStatus !==
                                EBillingStatus.SUCCEEDED && (
                                    <div
                                        className={cx(
                                            s.descriptionItem,
                                            s.descriptionItemMultiline
                                        )}
                                    >
                                        <span className={s.label}>Reason:</span>
                                        <span className={s.content}>
                                            {event.eventReason}
                                        </span>
                                    </div>
                                )}
                        </div>
                    ),
                }))}
            />
        </div>
    );
};

export default PaymentEvent;
